// import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';

import './ColoredDiamondCategoryPage.style';
import '../CategoryPage/CategoryPage.override.style';
import ContentWrapper from '@scandipwa/scandipwa/src/component/ContentWrapper';
import StepSection from 'Component/StepSection';
import CategoryDetails from '@scandipwa/scandipwa/src/component/CategoryDetails';
import { category } from 'Src/Value/category';
import ColoredDiamondFilter from 'Component/ColoredDiamondFilter';
import ColoredDiamondListing from 'Component/ColoredDiamondListing';
import { custmizesku } from 'Src/Value/customization';

export class ColoredDiamondCategoryPage extends PureComponent {
    static propTypes = {
        diamond: this.propTypes,
        fetchColorDiamond: this.propTypes,
        isLoading: this.propTypes,
    };

    renderCreateRingOption = () => {
        const stepCategory = "Diamond";
        const step = localStorage.getItem("step");

        if (step === null) {
            localStorage.setItem("step", stepCategory);
            localStorage.setItem("custmizesku", custmizesku?.finalring?.sku);
        }

        return (
            <StepSection
                category={stepCategory}
                hasColor={true}
            />
        )
    }

    renderCategoryDetails() {
        return (
            <CategoryDetails
                category={category?.colordiamondcategory}
                isCurrentCategoryLoaded={true}
            />
        );
    }

    renderGetDiamond = () => {
        const { fetchColorDiamond } = this.props;

        fetchColorDiamond();
    }

    renderContent() {
        const { diamond, isLoading } = this.props;

        return (
            <>
                {this.renderCreateRingOption()}
                {this.renderCategoryDetails()}
                <ColoredDiamondFilter renderGetDiamond={this.renderGetDiamond} />
                <ColoredDiamondListing diamond={diamond} isLoading={isLoading} />
            </>
        );
    }

    render() {
        return (
            <div className="ColoredDiamondCategoryPage CategoryPage">
                <ContentWrapper
                    wrapperMix={{
                        block: 'CategoryPage',
                        elem: 'Wrapper',
                    }}
                    label="Category page"
                >
                    {this.renderContent()}
                </ContentWrapper>
            </div>
        );
    }
}

export default ColoredDiamondCategoryPage;
